
import { fetchConToken } from "../../../helpers/fetch";
import { AppDispatch } from "../../store";

import { endLoadingNoticia, NoticiaState, setNoticias } from "./noticiaSlice";

export const obtenerNoticiasCurso = (cid: string) => {

    return async (dispatch: AppDispatch) => {

        try {
            const resp = await fetchConToken(`noticia/obtener/${cid}`);
            const body = await resp.json();

            if (body.ok) {
                const { noticias } = body;
                dispatch(setNoticias(noticias))
                dispatch(endLoadingNoticia());
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

// ADMINISTRADOR
export const crearNoticia = (noticia: object) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { noticias } = getState().noticia;

        try {
            const resp = await fetchConToken(`noticia/crear`, noticia, 'POST');
            const body = await resp.json();

            if (body.ok) {
                const { noticiaCreada } = body;
                const noticiasActualizada = [noticiaCreada, ...noticias]
                dispatch(setNoticias(noticiasActualizada))
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const eliminarNoticia = (id: string) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { noticias } = getState().noticia;

        try {
            const resp = await fetchConToken(`noticia/eliminar/${id}`, { id: id }, 'DELETE');
            const body = await resp.json();

            if (body.ok) {
                const { noticiaEliminada } = body;
                const noticiasActualizada = noticias.filter((item: NoticiaState) => item.id !== noticiaEliminada.id);
                dispatch(setNoticias(noticiasActualizada))
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const actualizarNoticia = (noticia: NoticiaState) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { id } = noticia; 

        const { noticias } = getState().noticia;

        try {
            const resp = await fetchConToken(`noticia/actualizar/${id}`, noticia, 'PUT');
            const body = await resp.json();

            if (body.ok) {
                const { noticiaActualizada } = body;

                const noticiasActualizada = noticias.map((item: NoticiaState) => 
                    item.id === id ? noticiaActualizada : item
                )

                dispatch(setNoticias(noticiasActualizada))
                dispatch(endLoadingNoticia());
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}